import { render, staticRenderFns } from "./PolygonalChartPrint.vue?vue&type=template&id=5b64a5b2&scoped=true&"
import script from "./PolygonalChartPrint.vue?vue&type=script&lang=js&"
export * from "./PolygonalChartPrint.vue?vue&type=script&lang=js&"
import style0 from "./PolygonalChartPrint.vue?vue&type=style&index=0&id=5b64a5b2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b64a5b2",
  null
  
)

export default component.exports